import { render, staticRenderFns } from "./ForgotPasswordDialog.vue?vue&type=template&id=ef58bf56&scoped=true"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordDialog.vue?vue&type=style&index=0&id=ef58bf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef58bf56",
  null
  
)

export default component.exports